const RadioCardGroup = ({
  options = [],
  name,
  selectedValue,
  onChange,
  variant = "lunch", // lunch | dinner
  containerClass = "",
}) => {
  const isDinner = variant === "dinner";

  const activeColor = isDinner
    ? "border-orange-500 bg-orange-50 "
    : "border-orange-500 bg-orange-50";

  const circleColor = isDinner ? "border-orange-500" : "border-orange-500";

  const dotColor = isDinner ? "bg-orange-500" : "bg-orange-500";

  return (
    <div className={`w-full max-w-md space-y-3 ${containerClass}`}>
      {options.map((option) => {
        const isActive = selectedValue === option.value;

        return (
          <label key={option.value} className="relative cursor-pointer block">
            {/* Hidden Radio */}

            <input
              type="radio"
              name={name}
              value={option.value}
              checked={isActive}
              onChange={(e) => onChange(e.target.value)}
              className="hidden"
            />

            {/* Card */}
            <div
              className={`flex items-center gap-4 p-3 rounded-xl border transition-all duration-300
    ${
      isActive
        ? "border-orange-500 bg-orange-50"
        : "border-gray-200 bg-white hover:border-gray-300"
    }
  `}
            >
              {/* Outer Circle */}
              <div
                className={`w-4 h-4 rounded-full border flex items-center justify-center transition-all duration-300
                  ${isActive ? circleColor : "border-gray-300"}
                `}
              >
                {/* Inner Dot */}
                <div
                  className={`w-2 h-2 rounded-full transition-transform duration-200
                    ${dotColor}
                    ${isActive ? "scale-100" : "scale-0"}
                  `}
                />
              </div>

              <span className="text-gray-700 text-sm font-medium">
                {option.label}
              </span>
            </div>
          </label>
        );
      })}
    </div>
  );
};

export default RadioCardGroup;
